import React, { Component } from 'react';

import Button from '../../../../common/Button/Button';
import Checkbox from '../../../../common/Checkbox/Checkbox';

import cn from 'classnames';
import styles from './Registration.scss';
import tracker from '../../../../../services/tracker';
import i18n from '../../../../../i18n';
import { withTranslation } from 'react-i18next';

const variants = {
  fz214: { param: 'fz214', key: 'ФЗ-214', text: i18n.t('components.header.filtersBar.filters.registration.fz214'), event: 'Web_Filters_FZ-214' },
  fz215: { param: 'fz215', key: 'ФЗ-215', text: i18n.t('components.header.filtersBar.filters.registration.fz215'), event: 'Web_Filters_FZ-215' },
  ust: { param: 'ust', key: 'Юстиция', text: i18n.t('components.header.filtersBar.filters.registration.ust'), event: 'Web_Filters_Justice' },
  inv: { param: 'inv', key: 'Договор инвестирования', text: i18n.t('components.header.filtersBar.filters.registration.inv') },
  preс: { param: 'prec', key: 'Предварительный договор', text: i18n.t('components.header.filtersBar.filters.registration.preс') },
  shared: { param: 'shared', key: 'Паевой взнос', text: i18n.t('components.header.filtersBar.filters.registration.shared') },
  reserv: { param: 'reserv', key: 'Договор бронирования', text: i18n.t('components.header.filtersBar.filters.registration.reserv') },
  loan: { param: 'loan', key: 'Договор займа', text: i18n.t('components.header.filtersBar.filters.registration.loan') },
  partnership: { param: 'partnership', key: 'Договор простого товарищества', text: i18n.t('components.header.filtersBar.filters.registration.partnership') },
  assignment: { param: 'assignment', key: 'Договор переуступки', text: i18n.t('components.header.filtersBar.filters.registration.assignment') }
};

export const parseSearch = (search) => {
  const { checkout } = search;
  if (!checkout) {
    return { checkout: [] };
  }
  const keys = checkout.split(',');
  return {
    checkout: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.param)) {
          prev.push(variant.key);
        }
        return prev;
      }, [])
  };
};

export const compileSearch = (data) => {
  const { checkout: keys } = data;
  if (!keys.length) {
    return { checkout: undefined };
  }

  return {
    checkout: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.key)) {
          prev.push(variant.param);
        }
        return prev;
      }, [])
      .join(',') || undefined
  };
};

export const compileRequest = (data) => {
  const { checkout } = data;
  return { checkout: checkout.length ? checkout : undefined };
};

export const getRequest = (search) => compileRequest(parseSearch(search));

export const subtext = (search) => {
  const { checkout: keys } = parseSearch(search);
  return Object.keys(variants)
    .reduce((prev, cur) => {
      const variant = variants[cur];
      if (keys.includes(variant.key)) {
        prev.push(variant.text);
      }
      return prev;
    }, [])
    .join(', ') || i18n.t('components.header.filtersBar.filters.registration.notSelected');
};

class Registration extends Component {
  constructor(props) {
    super(props);

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
  }

  handleClearClick() {
    const { dropdownData } = this.props;
    const data = { checkout: [] };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  handleCheckboxClick(key, add) {
    const { search, dropdownData, eventData } = this.props;
    const { checkout: keys } = parseSearch(search);
    const checkout = [...keys];

    tracker.sendVariantEvent({ variants, key, selected: add, eventData });

    if (checkout.includes(key) !== add) {
      if (add) {
        checkout.push(key);
      } else {
        checkout.splice(checkout.indexOf(key), 1);
      }
    }

    const data = { checkout };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key) {
    const { search } = this.props;
    const { checkout } = parseSearch(search);
    const variant = variants[key];
    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={checkout.includes(variant.key)}
        handle={this.handleCheckboxClick.bind(undefined, variant.key)}
        text={variants[key].text}
      />
    );
  }

  render() {
    const { className, additional, search, t } = this.props;
    const { checkout } = parseSearch(search);

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
        <p className={styles.Title}>
          {t('components.header.filtersBar.filters.registration.title')}
          {
            !!checkout.length &&
            <Button className={styles.Button} onClick={this.handleClearClick}>
              {t('components.header.filtersBar.filters.registration.clear')}
            </Button>
          }
        </p>
        <div className={styles.Checkboxes}>
          <div className={styles.FirstColumn}>
            {this.checkbox('fz214')}
            {this.checkbox('fz215')}

          </div>
          <div className={styles.SecondColumn}>
            {this.checkbox('ust')}
          </div>
        </div>

      </div>
    );
  }
}

export default withTranslation()(Registration);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Registration/Registration.js